export default __webpack_public_path__ + "static/media/unosat-blue-logo.47b4b606.svg";